var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prompt-wrap"},[(_vm.insTypeList)?_c('div',{staticClass:"risk-box"},[_c('dl',{staticClass:"risk"},[_vm._m(0),_c('dd',{staticClass:"bd"},_vm._l((_vm.insTypeList),function(item,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(item)+" ")])}),0)])]):_vm._e(),_c('div',{staticClass:"reminder"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('dt',{staticClass:"hd"},[_c('i',[_vm._v("风险提示")])])
}]

export { render, staticRenderFns }